import { render, staticRenderFns } from "./DemandaRoot.vue?vue&type=template&id=40387942&"
import script from "./DemandaRoot.vue?vue&type=script&lang=js&"
export * from "./DemandaRoot.vue?vue&type=script&lang=js&"
import style0 from "./DemandaRoot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports